import { Button } from '@/marketing/components/ui/button';
import type { ScoutingDecision } from '@/marketing/models/campaignScouting';
import { canReviewScouting, scoutingStatus, type ScoutingViewRow } from './scoutingView';
const SELECTED_TONE: Record<ScoutingDecision, string> = {
  Finalist: 'tw-border-emerald-600 tw-bg-emerald-100 tw-text-emerald-800',
  Maybe: 'tw-border-amber-700 tw-bg-amber-100 tw-text-amber-900',
  Declined: 'tw-border-red-600 tw-bg-red-100 tw-text-red-800',
};
export function ScoutingDecisionCell({
  row,
  disabled,
  onDecide,
}: {
  row: ScoutingViewRow;
  disabled: boolean;
  onDecide: (row: ScoutingViewRow, decision: ScoutingDecision) => void;
}) {
  const name = row.creator?.handle ?? row.influencerId;
  const editable = canReviewScouting(row);
  return (
    <div>
      <div className="tw-flex tw-gap-1">
        {(['Maybe', 'Finalist', 'Declined'] as const).map((decision) => (
          <Button
            key={decision}
            size="sm"
            variant="outline"
            aria-pressed={row.decision === decision}
            className={`tw-h-7 tw-px-2 tw-text-xs disabled:tw-opacity-100 ${row.decision === decision ? SELECTED_TONE[decision] : 'tw-bg-white tw-text-slate-700'}`}
            disabled={disabled || !editable || row.decision === decision}
            aria-label={`${decision === 'Declined' ? 'Decline' : 'Mark ' + decision} ${name}`}
            onClick={() => onDecide(row, decision)}
          >
            {decision === 'Declined' ? 'Decline' : decision}
          </Button>
        ))}
      </div>
      {!editable && (
        <p className="tw-mt-1 tw-text-[10px] tw-text-muted-foreground">
          {scoutingStatus(row) === 'Selected' ? 'Already selected' : 'Unavailable at this stage'}
        </p>
      )}
      {row.declineReason && (
        <details className="tw-mt-1 tw-max-w-xs tw-text-xs">
          <summary className="tw-cursor-pointer tw-text-muted-foreground">Decline reason</summary>
          <p className="tw-mt-1 tw-max-h-32 tw-overflow-y-auto tw-whitespace-pre-wrap tw-break-words">
            {row.declineReason}
          </p>
        </details>
      )}
    </div>
  );
}
